import { combineReducers } from 'redux';

import ux from '@store/reducers/ux';
import channels from '@store/reducers/channels';
import programs from './programs';
import results from './results';

export default combineReducers({
  ux,
  channels,
  programs,
  results,
});
